/* eslint tailwindcss/no-custom-classname: off */
interface Props {
  backgroundGray?: boolean
}
export const Space: React.FC<Props> = ({ backgroundGray }) => {
  if (backgroundGray) return <div className="flex1 back-gray-light"></div>
  return <div className="flex1"></div>
}
